import { api } from "./api";

export const FaqApi = (params) => {
  return api.get("/manufacturer/faq/faq-list", JSON.stringify(params));
};
